<template>
  <div>
    <header-view></header-view>
    <slot></slot>
    <footer-view></footer-view>
  </div>
</template>

<script>
import HeaderView from "@/components/header/index.vue";
import FooterView from "@/components/footer/index.vue";

export default {
  name: "LayoutView",
  components: { FooterView, HeaderView },
};
</script>

<style lang="scss">
.container {
  width: px2rem(1200);
  margin: 0 auto;
}
</style>
